import React from "react";

export default ({ width = 20, height = 20, color = "#FFF" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 20 20"
    width={width}
    height={height}
  >
    <defs>
      <path
        id="icon-file"
        d="M16 15c0 .6-.4 1-1 1H5a1 1 0 0 1 0-2h10c.6 0 1 .4 1 1zM5 10h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2zm13 7c0 .6-.4 1-1 1H3a1 1 0 0 1-1-1V3c0-.6.4-1 1-1h9v4c0 1.1.9 2 2 2h4v9zm1.7-11.3L14.3.3a1 1 0 0 0-.7-.3H2a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h16a2 2 0 0 0 2-2V6.4a1 1 0 0 0-.3-.7z"
      />
    </defs>
    <use fill={color} fillRule="evenodd" xlinkHref="#icon-file" />
  </svg>
);
